<template>
  <div class="goodNewsPage">
    <div style="width: 60%;height: 100%;padding: 20px;overflow: auto;padding-bottom: 60px;">
      <Base ref="base" />
      <Info ref="info" :detail="detail.pigLineCustomerInfo" :pigLineProductResult="detail.pigLineProductResult" />
      <Img ref="img" />
      <Empirical ref="empirical" :detail="detail" />
      <div style="text-align: center;position: fixed;left: 20px;right: calc(40% + 30px);bottom: 20px;background-color: #fff;padding: 20px 0;">
        <a-space>
          <a-button @click="getDefault">恢复初始数据</a-button>
          <a-button @click="submit" type="primary">生成预览</a-button>
        </a-space>
      </div>
    </div>
    <div style="width: 40%;padding: 20px;height: 100%;overflow: auto;">
      <NewsPreview />
    </div>
  </div>
</template>

<script>
import Base from './GoodNewsComponents/Base.vue';
import Img from './GoodNewsComponents/Img.vue';
// import Footer from './GoodNewsComponents/Footer.vue';
import NewsPreview from './GoodNewsComponents/NewsPreview.vue'
import Info from './GoodNewsComponents/Info.vue'
import Empirical from './GoodNewsComponents/Empirical.vue'
import { mapState, mapMutations } from 'vuex';
import api from './api'
export default {
  components: {Base,Img,Info,NewsPreview,Empirical},
  props: {},
  data() {
    return {
      componentArr: ['base','img','info','empirical'],
      detail: {},
      cacheData: {},
    }
  },
  watch: {},
  computed: {
    ...mapState('news', ['newsData','generateCount','imageUrlLeft','imageUrlRight']),
  },
  created() {},
  mounted() {
    this.getDetail()
  },
  methods: {
    ...mapMutations('news', ['setState']),
    async getDetail(){
      let {id} = this.$route.query
      let params = {
        recordId: id,
        lineType: 'PIG_LINE'
      }
      let res = await api.pigDetail(params)
      this.detail = res?.data || {}
      this.cacheData = JSON.stringify(res?.data || {})
      let {pigLineProductResult} = this.detail || {}
      let {weightCostRatio} = pigLineProductResult || {}
      this.setState({weightCostRatio})
    },
    async submit(){
      let newsData = {}
      if(!this.imageUrlLeft || !this.imageUrlRight){
        this.$message.warning('请选择喜报图片')
        return
      }
      await this.componentArr.forEach(async (el) => {
        let formData = await this.$refs[el].form.validateFields()
        Object.assign(newsData,formData)
      })
      this.setState({newsData: {...this.newsData,...newsData},generateCount: this.generateCount + 1})
    },
    getDefault(){
      this.detail = {}
      setTimeout(() => {
        this.detail = JSON.parse(this.cacheData)
      }, 0);
    },
  },
}
</script>
<style lang='scss'>
.goodNewsPage{
  height: calc(100% - 40px);
  overflow: auto;
  display: flex;
  background-color: #fff;
  margin-top: 20px;
  font-family: '思源黑体','思源-heavy', Avenir, Helvetica, Arial, sans-serif;
  .ant-form-item{
    margin-bottom: 0;
  }
}
.tips{
  color:#aaa;
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 0;
}
.componentTitle{
  font-weight: bold;
  font-size: 14px;
}
.uploadImg{
  width: 103px;
  height: 103px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position:center center;
}
</style>
<style lang='scss' scoped></style>